// monaco
import * as monaco from 'monaco-editor';
import { loader } from '@monaco-editor/react';
// Vite `?worker` virtual modules: the default export (a Worker constructor) is
// generated by Vite at build time, so import-x's static "no default export"
// check is a false positive (it resolves the physical .worker.js file instead).
// eslint-disable-next-line import-x/default
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
// eslint-disable-next-line import-x/default
import jsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';

/**
 * Monaco bootstrap.
 *
 * Hands a bundled ESM Monaco instance to `@monaco-editor/loader` so it never
 * injects the AMD CDN loader (`vs/loader.js`). That loader installs a global
 * `define`/`define.amd`, which races against the WebCall widget's UMD wrapper:
 * when `define.amd` wins the race, the widget takes its AMD branch and never
 * writes `globalThis.WebCallWidget` (it stays `undefined`). Bundling the ESM
 * build removes that global `define` entirely, so the race can no longer happen.
 *
 * This module must be imported before the first `<Editor>`/`useMonaco()` mounts
 * (i.e. before `loader.init()` runs) — see its import in `main.tsx`.
 */

declare global {
    var MonacoEnvironment: monaco.Environment | undefined;
}

globalThis.MonacoEnvironment = {
    getWorker(_workerId, label) {
        if (label === 'json') {
            return new jsonWorker();
        }
        return new editorWorker();
    }
};

loader.config({ monaco });
